import { render, staticRenderFns } from "./PreviewFormsAPS.vue?vue&type=template&id=0af96d52"
import script from "./PreviewFormsAPS.vue?vue&type=script&lang=ts"
export * from "./PreviewFormsAPS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports